import { render, staticRenderFns } from "./MultiAngleGeneration.vue?vue&type=template&id=0fbcf846&scoped=true"
import script from "./MultiAngleGeneration.vue?vue&type=script&lang=js"
export * from "./MultiAngleGeneration.vue?vue&type=script&lang=js"
import style0 from "./MultiAngleGeneration.vue?vue&type=style&index=0&id=0fbcf846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbcf846",
  null
  
)

export default component.exports